var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.906,
    height: 29.365,
    viewBox: "0 0 29.906 29.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contacts-book-svgrepo-com",
    transform: "translate(0 -8.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M845.4,66.4h-1.8v7.215h1.8a1.868,1.868,0,0,0,1.866-1.866V68.266A1.868,1.868,0,0,0,845.4,66.4Z",
    transform: "translate(-817.364 -55.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M847.27,372.749v-3.483A1.868,1.868,0,0,0,845.4,367.4h-1.8v7.215h1.8A1.867,1.867,0,0,0,847.27,372.749Z",
    transform: "translate(-817.364 -347.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M843.407,675.382c0,.078,0,.156-.006.233h1.81a1.868,1.868,0,0,0,1.866-1.866v-3.483a1.868,1.868,0,0,0-1.866-1.866h-1.8Z",
    transform: "translate(-817.171 -639.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M203.9,8.8a1.827,1.827,0,0,0-.6-.1H186.6V38.065h16.7a1.865,1.865,0,0,0,1.85-1.633,1.95,1.95,0,0,0,.016-.233V10.566a.547.547,0,0,0,0-.072A1.86,1.86,0,0,0,203.9,8.8Zm-8.689,14.042h-4.684a1.244,1.244,0,1,1,0-2.488h4.681a1.244,1.244,0,0,1,0,2.488Zm4.681-5.667h-9.364a1.244,1.244,0,1,1,0-2.488h9.364a1.244,1.244,0,0,1,0,2.488Z",
    transform: "translate(-180.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M1.266,8.8A1.863,1.863,0,0,0,0,10.566V36.2a1.868,1.868,0,0,0,1.866,1.866h1.76V8.7H1.866A1.814,1.814,0,0,0,1.266,8.8Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwWhite);
export default __webpack_public_path__ + "static/media/SW_White.1333aaf7f4c7eeef2dbffb4827633551.svg";
export { ForwardRef as ReactComponent };